// Display an ISO date ("YYYY-MM-DD", optionally with a time part) as DD.MM.YYYY.
// Timezone-safe — it never constructs a Date, so no UTC/local day shift.
// Passes through values that aren't ISO dates (e.g. already "07.09.2026").
export function fmtDateRO(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return d && d.length === 2 ? `${d}.${m}.${y}` : String(iso);
}
